"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shapeSimpleFilterForApi = exports.serializeStaticFilters = void 0;
function serializeStaticFilters(filter) {
    if (isCombinedFilter(filter)) {
        return JSON.stringify(shapeCombinedFilterForApi(filter));
    }
    return JSON.stringify(shapeSimpleFilterForApi(filter));
}
exports.serializeStaticFilters = serializeStaticFilters;
function shapeCombinedFilterForApi(combinedFilter) {
    const shapedFilters = [];
    for (const filter of combinedFilter.filters) {
        if (isCombinedFilter(filter)) {
            shapedFilters.push(shapeCombinedFilterForApi(filter));
        }
        else {
            shapedFilters.push(shapeSimpleFilterForApi(filter));
        }
    }
    return shapedFilters.length === 1
        ? shapedFilters[0]
        : { [combinedFilter.combinator]: shapedFilters };
}
function shapeSimpleFilterForApi(filter) {
    return {
        [filter.fieldId]: {
            [filter.comparator]: filter.comparedValue
        }
    };
}
exports.shapeSimpleFilterForApi = shapeSimpleFilterForApi;
function isCombinedFilter(filter) {
    return (filter.filters !== undefined)
        && (filter.combinator !== undefined);
}
